import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { HelpersService } from 'src/app/_services/helpers.service';

@Component({
  selector: 'app-aduan-tanggapan',
  templateUrl: './aduan-tanggapan.component.html',
  styleUrls: ['./aduan-tanggapan.component.scss'],
})
export class AduanTanggapanComponent implements OnInit {
  @Input() tanggapan: any;
  _albums = [];
  _pdfs = [];
  @Input() avatar: string = 'assets/images/ava-sidumas.png';

  constructor(public helper: HelpersService) {}

  ngOnInit() {
    // console.log(this.tanggapan);

    if (this.tanggapan.files.length > 0) {
      this.tanggapan.files.forEach((el) => {
        let album = {};
        let pdf = {};
        // console.log(el);

        if (el.is_image == '0') {
          pdf = {
            src: el.src,
            caption: el.id,
            thumb: 'assets/icon/png/pdf.png',
            type: 'pdf',
          };
          this._pdfs.push(pdf);
        } else {
          album = {
            src: '/' + el.filepath,
            caption: el.id,
            thumb: el.fullpath,
            type: 'image',
          };
          this._albums.push(album);
        }
      });
    }

    // console.log(this._pdfs);
  }
}
